(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kixi-infinite-products')) {
  customElements.define('kixi-infinite-products', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.section = this.closest('.shopify-section');
      this.grid = this.section?.querySelector('[data-testid="resource-list-grid"]');
      this.link = this.querySelector('[data-kixi-next]');
      this.status = this.querySelector('[data-kixi-status]');
      if (!this.grid || !this.link) return;
      this.seen = new Set(Array.from(this.grid.querySelectorAll('[data-kixi-product-id]'), item => item.dataset.kixiProductId));
      this.onClick = event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.failed = false;
        this.loadNext();
      };
      this.link.addEventListener('click', this.onClick);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.failed) this.loadNext();
        }, { rootMargin: '600px 0px' });
        this.observer.observe(this);
      }
    }
    async loadNext() {
      if (this.loading || !this.link || this.link.hidden || !this.isConnected) return;
      this.loading = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.link.setAttribute('aria-disabled', 'true');
      this.status.textContent = this.dataset.loading;
      this.request = new AbortController();
      try {
        const url = new URL(this.link.href, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Invalid pagination origin');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: this.request.signal });
        if (!response.ok) throw new Error('Product loading failed');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incomingSection = parsed.getElementById(this.section.id);
        const incomingGrid = incomingSection?.querySelector('[data-testid="resource-list-grid"]');
        const incomingControl = incomingSection?.querySelector('kixi-infinite-products');
        if (!incomingGrid || !incomingControl) throw new Error('Product section missing');
        const items = Array.from(incomingGrid.children).filter(item => item.dataset.kixiProductId && !this.seen.has(item.dataset.kixiProductId));
        if (!items.length) throw new Error('No new products returned');
        if (!this.isConnected) return;
        const fragment = document.createDocumentFragment();
        for (const item of items) {
          const productId = item.dataset.kixiProductId;
          // Static product-card block IDs repeat on each server-rendered page.
          const card = item.querySelector('product-card[id]');
          if (card) card.id = 'kixi-' + this.dataset.sectionId + '-' + productId;
          fragment.appendChild(item);
          this.seen.add(productId);
        }
        this.grid.appendChild(fragment);
        const nextLink = incomingControl.querySelector('[data-kixi-next]');
        if (nextLink) {
          this.link.setAttribute('href', nextLink.getAttribute('href'));
          this.status.textContent = '';
          // Re-observe after the grid grows, including on short mobile viewports.
          this.observer?.unobserve(this);
          requestAnimationFrame(() => { if (this.isConnected) this.observer?.observe(this); });
        } else {
          this.link.hidden = true;
          this.status.textContent = this.dataset.complete;
          this.observer?.disconnect();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.status.textContent = this.dataset.error;
        }
      } finally {
        this.loading = false;
        this.grid?.removeAttribute('aria-busy');
        this.link?.removeAttribute('aria-disabled');
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.observer?.disconnect();
      this.request?.abort();
      this.link?.removeEventListener('click', this.onClick);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
